import { Navigate, Route, Routes } from 'react-router-dom';

import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { UnderLicenseClaim } from '../../../components/new-layout/UnderLicenseClaim';
import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import { intl } from '../../../helpers/IntGlobalProvider';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import Text from '../../../react-components/Text';
import { DriversPODCanceled } from './DriversPODCanceled';
import { DriversPODCompleted } from './completed';

interface DriversPODProps {
  project: Project;
}

export const DriversPOD = ({ project }: DriversPODProps) => {
  // useEffect(() => {
  //   // TODO: SET THE CORRECT PAGE VIEW
  //   eventsPanel.pageView(PageViewPages.vehicles);
  // }, []);
  const { data: userCredentials } = useRetrieveUserCredentials();

  if (!userCredentials?.subscription.test(`drivers.advanced_pod`)) {
    return (
      <UnderLicenseClaim headerText={intl.formatMessage({ id: `drivers.pod.under_gorilla_claim.title` })}>
        <Grid container direction="column" alignItems="center">
          <VSpacer large />
          <VSpacer large />
          <VSpacer large />
          <VSpacer large />
          <VSpacer medium />

          <Grid
            item
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ maxWidth: `700px` }}
          >
            <VSpacer large />
            <Text
              style={{ textAlign: `center`, color: `#5073B5` }}
              variant="h6"
              intlId="drivers.pod.under_gorilla_claim.header"
            />
          </Grid>
        </Grid>
      </UnderLicenseClaim>
    );
  }

  return (
    <Routes>
      <Route index element={<Navigate to={routing.DRIVERS.APP.POD.COMPLETED.replace(`:projectId`, project.id)} />} />

      <Route path="/completed" element={<DriversPODCompleted project={project} />} />

      <Route path="/canceled" element={<DriversPODCanceled project={project} />} />

      <Route path="*" element={<Navigate to={routing.DRIVERS.APP.POD.COMPLETED.replace(`:projectId`, project.id)} />} />
    </Routes>
  );
};
